import { fetchQuery } from 'react-relay';

import useRelay from '@zego/hooks/useRelay';

export default function useQuery(query) {
  const { environment } = useRelay();

  async function execute(variables = {}) {
    const data = await fetchQuery(environment, query, variables);
    return data;
  }

  return execute;
}
